import { Box } from '@material-ui/core';
import './ActiveCardInformation.scss';
import { fontSizes, colors } from 'Theme/Variables';
import { useLocalization } from 'Hooks';

const ActiveCardInformation = () => {
  const localization = useLocalization();
  const web_pc_istanbulcard_activecard_info_title = (localization as any)?.web_pc_istanbulcard_activecard_info_title;
  const web_pc_istanbulcard_activecard_info_desc = (localization as any)?.web_pc_istanbulcard_activecard_info_desc;

  return (
    <Box id="activeCard-information" marginTop={'6px'}>
      <Box
        fontWeight={700}
        fontSize={fontSizes.regular}
        marginBottom={'8px'}
        color={colors.secondary}
        letterSpacing={'-0.4px'}
        lineHeight={'22px'}
      >
        {web_pc_istanbulcard_activecard_info_title || 'Bilgilendirme'}
      </Box>
      <Box
        fontWeight={400}
        fontSize={fontSizes.regular}
        color={colors.secondary}
        letterSpacing={'-0.4px'}
        lineHeight={'22px'}
      >
        {web_pc_istanbulcard_activecard_info_desc ||
          "İstanbulkart Plus'ın detaylarına ulaşmak için mobil uygulamayı kullanabilirsiniz."}
      </Box>
    </Box>
  );
};

export default ActiveCardInformation;
